.formLayout {
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    width: 40rem;
  }

  legend,
  p,
  ul,
  :global(.choiceList) {
    width: 32rem;
  }
}

.formSection {
  display: flex;
  flex-direction: column;
  gap: var(--space-md-lg);
}

.formRow {
  display: flex;
  gap: var(--space-md-lg);
}

.formField {
  display: flex;
  flex-direction: column;
  gap: var(--space-sm);

  > span:global(.label) {
    color: var(--text-color-header);
    font-weight: bold;
  }
}

.rootFieldset {
  border: none;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 2.5rem;
}

.formAlert {
  overflow: hidden;
  margin: -2.5rem -5rem 2rem -5rem;
}

.formControls {
  display: flex;
  gap: var(--space-md-lg);
}
